import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_ACCESS.md — code 建立後不可改 */
export async function updateRole(id, payload) {
  const body = { ...(payload ?? {}) };
  delete body.code;
  const { data: raw } = await request.patch(
    `/system/role/${id}`,
    keysToSnake(body),
  );
  return parseVer4DetailResponse(raw);
}
